export default __webpack_public_path__ + "static/media/watering-can.424d2d82.png";